import {
  ChakraFlex,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

interface ConfirmNewProfileCreationModalProps {
  id: string;
  isOpen: boolean;
  onCancel: () => void;
  onCancelParent: () => void;
  onCreateNewProfile: () => void;
}

const ModalContent = {
  title: 'Confirm new profile creation',
  subTitle:
    'A new patient profile will be created using the data from this inquiry. Please only create a new profile if there isn’t already a valid match.',
};

const ConfirmNewProfileCreationModal = ({
  id,
  isOpen,
  onCancel,
  onCancelParent,
  onCreateNewProfile,
}: ConfirmNewProfileCreationModalProps) => {
  const TOP_LEVEL_ID = `${id}__confirm-new-profile-modal`;

  const handleOnCreatePatient = () => {
    onCreateNewProfile();
    onCancelParent();
    onCancel();
  };
  return (
    <ModalV2
      footerContent={
        <ChakraFlex justifyContent="space-between" width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}__cancel`}
            leftIcon={FAIconName.chevronLeftRegular}
            onClick={onCancel}
            variant="secondary"
          >
            Back
          </FireflyButton>
          <FireflyButton
            id={`${TOP_LEVEL_ID}__confirm`}
            leftIcon={FAIconName.checkRegular}
            onClick={handleOnCreatePatient}
            variant="primary"
          >
            Create new profile
          </FireflyButton>
        </ChakraFlex>
      }
      id={`${TOP_LEVEL_ID}__modal`}
      isOpen={isOpen}
      onClose={onCancel}
      size="lg"
      title={ModalContent.title}
    >
      <Text alignSelf="start" id={`${id}-subtitle`} variant="body">
        {ModalContent.subTitle}
      </Text>
    </ModalV2>
  );
};

export default ConfirmNewProfileCreationModal;
